import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import config from "../../config";
import {
  deletePermission,
  getPermissions
} from "../../redux/actions/Permissions";
import Modal from "../../components/Modal/Modal";
import PermissionsFilter from "./PermissionsFilter";
import CloseButton from "../../components/CloseButton/CloseButton";
import LinkDropdown from "../../components/LinkDropdown/LinkDropdown";

class Permissions extends React.Component {
  state = {
    name: "",
    deleteModal: null
  };

  componentWillMount() {
    this.props.getPermissions();
  }

  getFilteredPermissions() {
    return this.props.permissions.filter(permission =>
      permission.name.toLowerCase().includes(this.state.name.toLowerCase())
    );
  }

  getDeleteModalByPermission(permission) {
    return (
      <Modal
        title={permission.name}
        onClose={() => {
          this.setState({
            deleteModal: null
          });
        }}
        onSubmit={() => {
          this.props.remove(permission);
          this.setState({
            deleteModal: null
          });
        }}
      >
        Are you sure you want to delete?
      </Modal>
    );
  }

  render() {
    const { deleteModal, updateModal } = this.state;

    return (
      <div>
        <h1>Permissions</h1>
        <PermissionsFilter
          onChange={e => {
            this.setState({
              [e.target.name]: e.target.value
            });
          }}
        />
        <LinkDropdown header={"Manage"}>
          <Link to="/permission/create">Create</Link>
        </LinkDropdown>
        <table className="table table-sm table-responsive-md">
          <thead>
            <tr>
              <th>Permission</th>
              <th>Last permitted</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {this.getFilteredPermissions().map((permission, key) => (
              <tr key={key}>
                <td title={permission.description} onClick={() => {}}>
                  {permission.name}
                </td>
                <td>
                  {permission.last_permitted_at
                    ? moment(permission.last_permitted_at).format("MMM Do YYYY")
                    : "Never"}
                </td>
                <td>
                  {protectedPermissions().includes(permission.name) ? (
                    ""
                  ) : (
                    <CloseButton
                      onClick={() => {
                        this.setState({
                          deleteModal: this.getDeleteModalByPermission(
                            permission
                          )
                        });
                      }}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {deleteModal}
        {updateModal}
      </div>
    );
  }
}

const protectedPermissions = () =>
  config.protectedPermissions.map(protectedPermission => {
    return protectedPermission.permission;
  });

const mapStateToProps = ({ permissions }) => ({ permissions });

const mapDispatchToProps = dispatch => {
  return {
    getPermissions: () => {
      return dispatch(getPermissions());
    },
    remove: permission => {
      dispatch(deletePermission(permission));
    },
    update: (permission, description) => {}
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Permissions);



// WEBPACK FOOTER //
// ./src/containers/PermissionsPage/PermissionsPage.js